import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { AuthRepositoryImpl } from "../../data/repository/auth_repository_impl";
import { ChangePasswordInterface } from "../interface/change_password_interface";

export const useChangePassword = () => {
    const repository = new AuthRepositoryImpl();

    return useMutation<void, AxiosError, ChangePasswordInterface>({
        mutationFn: (payload: ChangePasswordInterface) => repository.changePassword(payload),
    });
};
